var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C11D6C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "internet-connect-app-mobile-smartphone"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.29,31.32v-6.16c0-8.38-6.79-15.17-15.17-15.17H31.26c-8.38,0-15.17,6.79-15.17,15.17V37.3h-3.03 c-1.68,0-3.03,1.36-3.03,3.03v12.13c0,1.68,1.36,3.03,3.03,3.03h3.03v12.13h-3.03c-1.68,0-3.03,1.36-3.03,3.03V82.8 c0,1.68,1.36,3.03,3.03,3.03h3.03v91c0,8.38,6.79,15.17,15.17,15.17h78.87c8.38,0,15.17-6.79,15.17-15.17v-6.16 c38.48-1.65,68.34-34.17,66.7-72.66C190.44,61.85,161.46,32.87,125.29,31.32L125.29,31.32z M46.42,16.07h48.53v3.03 c0,1.68-1.36,3.03-3.03,3.03H49.46c-1.68,0-3.03-1.36-3.03-3.03V16.07z M119.22,176.83c-0.01,5.02-4.08,9.09-9.1,9.1H31.26 c-5.02-0.01-9.09-4.08-9.1-9.1V25.17c0.01-5.02,4.08-9.09,9.1-9.1h9.1v3.03c0.01,5.02,4.08,9.09,9.1,9.1h42.47 c5.02-0.01,9.09-4.08,9.1-9.1v-3.03h9.1c5.02,0.01,9.08,4.08,9.1,9.1v6.16c-38.48,1.65-68.34,34.17-66.7,72.66 c1.55,36.17,30.52,65.15,66.7,66.7V176.83z M122.26,164.7c-35.18,0-63.7-28.52-63.7-63.7s28.52-63.7,63.7-63.7 s63.7,28.52,63.7,63.7C185.92,136.16,157.42,164.66,122.26,164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.26,58.53c-19.31-0.03-37.84,7.64-51.46,21.33l4.28,4.3c26.03-26.06,68.25-26.08,94.31-0.05 c0.02,0.02,0.04,0.04,0.05,0.05l4.28-4.3C160.09,66.18,141.57,58.5,122.26,58.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.37,88.45l4.29,4.29c21.27-21.31,55.8-21.35,77.11-0.07c0.02,0.02,0.05,0.05,0.07,0.07l4.29-4.29 c-23.64-23.68-62.01-23.72-85.69-0.08C79.42,88.4,79.4,88.43,79.37,88.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.96,97.04l4.29,4.29c16.52-16.57,43.35-16.62,59.92-0.09c0.03,0.03,0.06,0.06,0.09,0.09l4.29-4.29 c-18.89-18.94-49.56-18.99-68.5-0.1C88.02,96.97,87.99,97,87.96,97.04L87.96,97.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.52,105.58l4.28,4.3c11.85-11.85,31.06-11.85,42.92,0l4.28-4.3C133.77,91.38,110.74,91.38,96.52,105.58 L96.52,105.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.1,114.17l4.29,4.29c7.11-7.11,18.63-7.11,25.74,0c0,0,0,0,0,0l4.29-4.29 C129.94,104.7,114.57,104.7,105.1,114.17C105.1,114.17,105.1,114.17,105.1,114.17L105.1,114.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.26,119.2c-6.7,0-12.13,5.43-12.13,12.13c0,6.7,5.43,12.13,12.13,12.13s12.13-5.43,12.13-12.13 C134.39,124.63,128.96,119.2,122.26,119.2z M122.26,137.4c-3.35,0-6.07-2.72-6.07-6.07c0-3.35,2.72-6.07,6.07-6.07 s6.07,2.72,6.07,6.07C128.32,134.68,125.61,137.4,122.26,137.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.75ebadcec72044ae289bffe688759eb3.svg";
export { ForwardRef as ReactComponent };